import { useContext } from "react";

import {
  AuthContext,
  type AuthContextValue,
} from "@/contexts/auth-context";

/**
 * Hook idiomático para consumir AuthContext.
 *
 * Lanza si se usa fuera de <AuthProvider> — eso es bug del programador,
 * no caso a manejar runtime.
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error("useAuth() debe usarse dentro de <AuthProvider>");
  }
  return ctx;
}
